import axios from 'axios';
import {
  GET_HOME_IMAGES,
  GET_NEW_HOME_IMAGE,
  GET_DELETED_HOME_IMAGE,
  HOME_IMAGES_LOADING,
  GET_ERRORS
} from './types';

// Create homeImage
export const createHomeImage = (homeImageData, history) => (dispatch) => {
  axios
    .post('/api/users/admin/home', homeImageData)
    .then((res) => {
      dispatch({
        type: GET_NEW_HOME_IMAGE,
        payload: res.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};

// Delete homeImage
export const deleteHomeImage = (homeImage_id) => (dispatch) => {
  axios
    .delete(`/api/users/admin/home/${homeImage_id}`)
    .then((res) => {
      dispatch({
        type: GET_DELETED_HOME_IMAGE,
        payload: res.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};

// Get all homeImage
export const getHomeImages = () => (dispatch) => {
  dispatch(setHomeImageLoading());
  axios
    .get('/api/users/admin/home')
    .then((res) =>
      dispatch({
        type: GET_HOME_IMAGES,
        payload: res.data,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_HOME_IMAGES,
        payload: null,
      })
    );
};

// Info loading
export const setHomeImageLoading = () => {
  return {
    type: HOME_IMAGES_LOADING,
  };
};
